import { createSlice } from "@reduxjs/toolkit";

import {
  changeProfilePassword,
  deleteUser2FAOtp,
  fetchProfile,
  fetchUser2FAOtpUrl,
  verifyUser2FAOtp
} from "../../actions/actions";
import {
  createLicenseRequest,
  fetchLicenseRequests
} from "../../actions/billing/billingData";
import mixpanel from "mixpanel-browser";

const initialState = {
  userProfile: undefined,
  profileLoading: false,
  profilePwdChanging: false,
  // billing states
  billingRequestList: [],
  billingRequestListCount: 0,
  billingRequestListPage: 1,
  billingRequestListPageSize: 10,
  billingRequestListLoading: true,
  billingRequestListCreating: false,
  // profile 2FA otp
  isProfile2FAOtpLoading: false,
  profile2FAOtpAuthUrl: "",
  profile2FAOtp: "",
  profile2FAOtpVerifying: false,
  profile2FAOtpDeleting: false,
  // change password
  changeCurrentPwd: "",
  changeCurrentNewPwd: "",
  changeCurrentConfirmPwd: "",
  skeletonData: [
    {
      height: 40,
      marginBottom: "10px"
    },
    {
      height: 100,
      marginBottom: "8px"
    },
    {
      height: 100,
      marginBottom: "8px"
    },
    {
      height: 100,
      marginBottom: "8px"
    },
    {
      height: 100,
      marginBottom: "8px"
    }
  ]
};

export const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    // Common update
    setProfileSliceData: (state, { payload }) => {
      if (payload.type && payload.type in state) {
        state[payload.type] = payload.data;
      }
    },
    setUserProfile: (state, { payload }) => {
      state.profile = payload;
    },
    updateFAEnabledInProfile: (state, action) => {
      state.userProfile.fa_enabled = action.payload;
    }
  },
  extraReducers: {
    [fetchProfile.pending]: (state) => {
      state.profileLoading = true;
    },
    [fetchProfile.fulfilled]: (state, { payload }) => {
      state.profileLoading = false;
      state.userProfile = payload;
      mixpanel.identify(payload.user_id);
      mixpanel.people.set_once({
        email: payload.email,
        mobile_number: payload.phone_no,
        name: `${payload.first_name} ${payload.last_name}`
      });
    },
    [fetchProfile.rejected]: (state) => {
      state.profileLoading = false;
    },
    [fetchLicenseRequests.pending]: (state) => {
      state.billingRequestListLoading = true;
    },
    [fetchLicenseRequests.fulfilled]: (state, { payload }) => {
      state.billingRequestListLoading = false;
      state.billingRequestList = payload?.results ? payload.results : [];
      state.billingRequestListCount = payload?.count ? payload.count : 0;
    },
    [fetchLicenseRequests.rejected]: (state) => {
      state.billingRequestListLoading = false;
    },
    [createLicenseRequest.pending]: (state) => {
      state.billingRequestListCreating = true;
    },
    [createLicenseRequest.fulfilled]: (state, { payload }) => {
      state.billingRequestListCreating = false;
    },
    [createLicenseRequest.rejected]: (state) => {
      state.billingRequestListCreating = false;
    },
    [fetchUser2FAOtpUrl.pending]: (state) => {
      state.isProfile2FAOtpLoading = true;
    },
    [fetchUser2FAOtpUrl.fulfilled]: (state, { payload }) => {
      state.profile2FAOtpAuthUrl = payload?.url;
      state.isProfile2FAOtpLoading = false;
    },
    [fetchUser2FAOtpUrl.rejected]: (state, { payload }) => {
      state.isProfile2FAOtpLoading = false;
    },
    [verifyUser2FAOtp.pending]: (state) => {
      state.profile2FAOtpVerifying = true;
    },
    [verifyUser2FAOtp.fulfilled]: (state, { payload }) => {
      state.profile2FAOtpVerifying = false;
    },
    [verifyUser2FAOtp.rejected]: (state, { payload }) => {
      state.profile2FAOtpVerifying = false;
    },
    [deleteUser2FAOtp.pending]: (state) => {
      state.profile2FAOtpDeleting = true;
    },
    [deleteUser2FAOtp.fulfilled]: (state, { payload }) => {
      state.profile2FAOtpDeleting = false;
    },
    [deleteUser2FAOtp.rejected]: (state, { payload }) => {
      state.profile2FAOtpDeleting = false;
    },
    [changeProfilePassword.pending]: (state) => {
      state.profilePwdChanging = true;
    },
    [changeProfilePassword.fulfilled]: (state, { payload }) => {
      state.profilePwdChanging = false;
    },
    [changeProfilePassword.rejected]: (state, { payload }) => {
      state.profilePwdChanging = false;
    }
  }
});

export const { setProfileSliceData, setUserProfile, updateFAEnabledInProfile } =
  profileSlice.actions;

export default profileSlice.reducer;
